import { z } from 'zod';
const BaseEventSchema = z.object({
    id: z.string().uuid(),
    sessionId: z.string().uuid(),
    ts: z.string().datetime(),
});
export const PromptEventSchema = BaseEventSchema.extend({
    type: z.literal('prompt'),
    projectId: z.string().uuid().optional(),
    model: z.string().optional(),
    provider: z.string().optional(),
    promptText: z.string().optional(),
    promptHash: z.string().optional(),
    responseText: z.string().optional(),
    inputTokens: z.number().int().nonnegative().optional(),
    outputTokens: z.number().int().nonnegative().optional(),
    totalTokens: z.number().int().nonnegative().optional(),
    latencyMs: z.number().int().nonnegative().optional(),
    costUsd: z.number().int().nonnegative().optional(),
    metadata: z.record(z.any()).optional(),
});
export const ExecutionEventSchema = BaseEventSchema.extend({
    type: z.literal('execution'),
    promptId: z.string().uuid().optional(),
    projectId: z.string().uuid().optional(),
    agent: z.string().optional(),
    executionType: z.string().optional(),
    status: z.enum(['pending', 'running', 'completed', 'failed', 'cancelled']),
    durationMs: z.number().int().nonnegative().optional(),
    success: z.boolean().optional(),
    exitCode: z.number().int().optional(),
    summary: z.string().optional(),
    diffHash: z.string().optional(),
    artifactUrl: z.string().url().optional(),
    errorMessage: z.string().optional(),
    metadata: z.record(z.any()).optional(),
});
export const HeartbeatEventSchema = BaseEventSchema.extend({
    type: z.literal('heartbeat'),
    deviceId: z.string().uuid(),
});
export const EventSchema = z.discriminatedUnion('type', [
    PromptEventSchema,
    ExecutionEventSchema,
    HeartbeatEventSchema,
]);
export const BatchEventsRequestSchema = z.object({
    events: z.array(EventSchema).min(1).max(50),
});
export const EventResultSchema = z.object({
    id: z.string().uuid(),
    accepted: z.boolean(),
    error: z.string().optional(),
});
export const BatchEventsResponseSchema = z.object({
    accepted: z.array(z.string().uuid()),
    rejected: z.array(z.object({
        id: z.string().uuid(),
        error: z.string(),
    })),
    summary: z.object({
        total: z.number().int(),
        accepted: z.number().int(),
        rejected: z.number().int(),
    }),
});
export const EventValidationErrorSchema = z.object({
    error: z.string(),
    code: z.enum([
        'INVALID_EVENT_TYPE',
        'MISSING_REQUIRED_FIELD',
        'INVALID_UUID',
        'INVALID_TIMESTAMP',
        'BATCH_TOO_LARGE',
        'RATE_LIMIT_EXCEEDED',
    ]),
    details: z.record(z.any()).optional(),
});
//# sourceMappingURL=events-contracts.js.map